import { apiClient } from "../config";

async function updateFileAttachmentStatus(
  fileId: string,
  isAttached: boolean = false
) {
  const res = await apiClient.put(
    `/admin/file/${encodeURIComponent(fileId)}/is-attached?is_attached=${isAttached}`,
    null,
    {
      headers: {
        accept: "application/json",
      },
    }
  );

  return res.data;
}

export default updateFileAttachmentStatus;
